module.exports = __webpack_public_path__ + "static/img/login-logo.36b24ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/login/login-logo.png
// module id = st1A
// module chunks = 1